import { useState, useCallback, Fragment } from 'react'
import classnames from 'classnames'
import Image from '../image'
import BackArrowTransparent from '../svg/back-arrow-transparent'
import NextArrowTransparent from '../svg/next-arrow-transparent'

export default function MobileGallery({ initialIndex = 0, images, onReportClick }) {
  const [index, setIndex] = useState(initialIndex)

  let xDown = null
  let yDown = null

  const handleImageSwitch = useCallback(
    (newIndex) => {
      if (images.length === newIndex) setIndex(0)
      else if (newIndex === -1) setIndex(images.length - 1)
      else setIndex(newIndex)
    },
    [images.length],
  )

  const handleTouchStart = (e) => {
    const firstTouch = e.touches[0]
    xDown = firstTouch.clientX
    yDown = firstTouch.clientY
  }

  const handleTouchMove = (e) => {
    if (!xDown || !yDown) {
      return
    }

    const xUp = e.touches[0].clientX
    const yUp = e.touches[0].clientY

    const xDiff = xDown - xUp
    const yDiff = yDown - yUp

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        handleImageSwitch(index + 1)
      } else {
        handleImageSwitch(index - 1)
      }
    }

    xDown = null
    yDown = null
  }

  return (
    <div className='wrapper' onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
      <div className='gallery'>
        <button
          className={classnames('backArrow', { disabled: index === 0 })}
          onClick={() => handleImageSwitch(index - 1)}
          disabled={index === 0}
        >
          <BackArrowTransparent />
        </button>

        {images.map((entry, i) => (
          <Fragment key={entry.url + i}>
            <Image
              src={entry.url}
              width='1024'
              height='576'
              className={classnames('galleryItem', { active: i === index })}
              alt='car'
              fullRes
            />
            <button
              className='flatBtn report'
              onClick={() => onReportClick(images[index]?.photoType, images[index]?.id)}
            >
              Report
            </button>
          </Fragment>
        ))}

        <button
          className={classnames('nextArrow', { disabled: index + 1 === images.length })}
          onClick={() => handleImageSwitch(index + 1)}
          disabled={index + 1 === images.length}
        >
          <NextArrowTransparent />
        </button>

        <div className='scrollProgress'>
          {index + 1}/{images.length}
        </div>
      </div>

      <style jsx>
        {`
          .wrapper {
            width: 100%;
          }

          .gallery {
            position: relative;
            overflow: hidden;
            width: 100%;
            padding: calc(4.6 / 8.2 * 100%) 0 0 0;
          }

          :global(.galleryItem) {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: -1;
          }

          :global(.galleryItem.active) {
            z-index: 1;
          }

          .scrollProgress {
            position: absolute;
            bottom: 0;
            left: 0;
            background: var(--primary-text-color);
            opacity: 0.79;
            color: #fff;
            z-index: 2;
            padding: 0.5rem 1.1rem 0.6rem 1.3rem;
            margin: 0 0 1.1rem 1.2rem;
            border-radius: 3.9rem;
            line-height: 1.4rem;
            font-weight: 700;
          }

          .report {
            background: rgba(0, 0, 0, 0.47) !important;
            padding: 0.6rem;
            border-radius: 1rem;
            position: absolute;
            bottom: 1.1rem;
            right: 1.2rem;
            z-index: 2;
            color: #fff;
            text-decoration: underline;
            font-size: 1.2rem;
          }

          .backArrow,
          .nextArrow {
            position: absolute;
            cursor: pointer;
            z-index: 1;
            top: 50%;
            transform: translate(0, -50%);
            background: transparent;

            &.disabled {
              cursor: not-allowed;
              opacity: 0.3;
            }
          }

          .nextArrow {
            right: 0.9rem;
          }

          .backArrow {
            left: 0.9rem;
            z-index: 2;
          }
        `}
      </style>
    </div>
  )
}
